// Super simple tooltip plugin
//
// Example: <span title="My tooltip!" x-data x-tooltip>Hover me!</span>
export default Alpine => {
  Alpine.directive('tooltip', (el, {}, { effect }) => {
    let tooltip = document.createElement('span')
    tooltip.textContent = el.getAttribute('title')
    tooltip.classList.add('x-tooltip')
    el.prepend(tooltip)
    el.removeAttribute('title')
  })
}
